import {Box, Skeleton, SkeletonProps, Stack, SxProps, useTheme} from '@mui/material';
import {useAppContext} from '../../contexts/app/context';
import {ThemeMode} from '../../enums/theme-mode';

const SKELETON_DEFAULT_PROPS = {
  animation: 'wave',
  variant: 'rounded',
} as SkeletonProps;

export const SystemEntitiesCardSkeleton = () => {
  const theme = useTheme();

  const AppContext = useAppContext();

  const outterBoxSx: SxProps = {
    flex: 1,
    padding: '0 9px',
    flexGrow: 1,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    width: '200px',
    height: '226px',
    borderRadius: '5px',
    boxShadow: '0px -3px 14px rgba(29, 41, 57, 0.15)',
    backgroundColor:
      AppContext.state.currentThemeMode === ThemeMode.Light
        ? theme.palette.background.paper
        : theme.palette.grey[900],
  };

  const innerBoxSx: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '42px',
    gap: '12px',
  };

  return (
    <Box sx={outterBoxSx}>
      <Stack sx={innerBoxSx}>
        <Skeleton {...SKELETON_DEFAULT_PROPS} width={76} height={76} variant="circular" />
        <Skeleton {...SKELETON_DEFAULT_PROPS} width={160} height={15} />
        <Skeleton {...SKELETON_DEFAULT_PROPS} width={110} height={15} />
      </Stack>
    </Box>
  );
};
